// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"448":"polyfills-dom","488":"polyfills-core-js"}[chunkId] || chunkId) + "." + {"448":"d716a10f","488":"7dccf47e","844":"e33ff566"}[chunkId] + ".chunk.js";
};